'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ownerState"];
import * as React from 'react';
import { animated } from '@react-spring/web';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @ignore - internal component.
 */
export function AnimatedBarElement(props) {
  const {
      ownerState
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(animated.rect, _extends({}, other, {
    filter: ownerState.isHighlighted ? 'brightness(120%)' : undefined,
    opacity: ownerState.isFaded ? 0.3 : 1
  }));
}